/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAddiServByWareBillTypeRespVo
 */
export interface GetAddiServByWareBillTypeRespVo {
    /**
     * 附加服务ID
     * @type {number}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    id?: number;
    /**
     * 附加服务名称
     * @type {string}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    name?: string;
    /**
     * 附加服务名称-中
     * @type {string}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    nameCn?: string;
    /**
     * 附加服务编码
     * @type {string}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    code?: string;
    /**
     * 附加服务分组编号
     * @type {number}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    groupId?: number;
    /**
     * 附加服务分组名称
     * @type {string}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    groupName?: string;
    /**
     * 附加服务分组名称-中
     * @type {string}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    groupNameCn?: string;
    /**
     * 附加服务分组排序
     * @type {number}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    groupSort?: number;
    /**
     * 账单类型编号
     * @type {number}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    billType?: number;
    /**
     * 价格
     * @type {number}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    price?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    currencyCode?: string;
    /**
     * 仓库编号
     * @type {number}
     * @memberof GetAddiServByWareBillTypeRespVo
     */
    warehouseId?: number;
}

/**
 * Check if a given object implements the GetAddiServByWareBillTypeRespVo interface.
 */
export function instanceOfGetAddiServByWareBillTypeRespVo(value: object): value is GetAddiServByWareBillTypeRespVo {
    return true;
}

export function GetAddiServByWareBillTypeRespVoFromJSON(json: any): GetAddiServByWareBillTypeRespVo {
    return GetAddiServByWareBillTypeRespVoFromJSONTyped(json, false);
}

export function GetAddiServByWareBillTypeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAddiServByWareBillTypeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'code': json['code'] == null ? undefined : json['code'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupNameCn': json['groupNameCn'] == null ? undefined : json['groupNameCn'],
        'groupSort': json['groupSort'] == null ? undefined : json['groupSort'],
        'billType': json['billType'] == null ? undefined : json['billType'],
        'price': json['price'] == null ? undefined : json['price'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
    };
}

export function GetAddiServByWareBillTypeRespVoToJSON(json: any): GetAddiServByWareBillTypeRespVo {
    return GetAddiServByWareBillTypeRespVoToJSONTyped(json, false);
}

export function GetAddiServByWareBillTypeRespVoToJSONTyped(value?: GetAddiServByWareBillTypeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'nameCn': value['nameCn'],
        'code': value['code'],
        'groupId': value['groupId'],
        'groupName': value['groupName'],
        'groupNameCn': value['groupNameCn'],
        'groupSort': value['groupSort'],
        'billType': value['billType'],
        'price': value['price'],
        'currencyCode': value['currencyCode'],
        'warehouseId': value['warehouseId'],
    };
}

